import * as React from 'react';
import './style.less';
import Icon from 'telstra-ui/components/icons/Icon';
import { NavLink } from 'react-router-dom';

// eslint-disable-next-line react/prop-types
export const ServerErrorWithCloud = ({ tryAgain }) => {
    const tryAgainElem = (
        <span onClick={tryAgain} className="try-again-styling">
            try again
        </span>
    );

    return (
        <div className="tc-srm">
            <div className="server-error-with-cloud row">
                <div className="size-error-component col-sm-12">
                    <div className="align-error-cloud">
                        <svg className="icon-size">
                            <Icon name="icon-system-server-error" />
                        </svg>
                    </div>
                    <div className="hidden-xs try-again body18">
                        <span>
                            The system is unresponsive. Please {tryAgainElem} in a few minutes.
                        </span>{' '}
                        <span>If that does not fix it, please
                            <NavLink to="/app/support/error-report">{' '}report this error</NavLink>.
                        </span>
                    </div>
                    <div className="visible-xs">
                        <div className="mobile-view-try-again body18">
                            <span>The system is unresponsive. Please {tryAgainElem} in a few minutes. </span>
                            <span>If that does not fix it, please
                                <NavLink to="/app/support/error-report">{' '}report this error</NavLink>.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
